import { render, staticRenderFns } from "./LotGroupTitle.vue?vue&type=template&id=1a10a8c4&scoped=true"
import script from "./LotGroupTitle.vue?vue&type=script&lang=js"
export * from "./LotGroupTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10a8c4",
  null
  
)

export default component.exports